var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 26.28C17.24 26.74 16.67 26.97 15.99 26.97C15.31 26.97 14.74 26.74 14.28 26.28L3.72 15.72C3.5 15.5 3.325 15.24 3.195 14.94C3.065 14.64 3 14.32 3 13.98V5.4C3 4.74 3.235 4.175 3.705 3.705C4.175 3.235 4.74 3 5.4 3H13.98C14.32 3 14.64 3.065 14.94 3.195C15.24 3.325 15.5 3.5 15.72 3.72L26.28 14.31C26.74 14.77 26.97 15.335 26.97 16.005C26.97 16.675 26.74 17.24 26.28 17.7L17.7 26.28ZM8.4 10.2C8.9 10.2 9.325 10.025 9.675 9.675C10.025 9.325 10.2 8.9 10.2 8.4C10.2 7.9 10.025 7.475 9.675 7.125C9.325 6.775 8.9 6.6 8.4 6.6C7.9 6.6 7.475 6.775 7.125 7.125C6.775 7.475 6.6 7.9 6.6 8.4C6.6 8.9 6.775 9.325 7.125 9.675C7.475 10.025 7.9 10.2 8.4 10.2Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSales);
export default __webpack_public_path__ + "static/media/TotalSales.8ecbec56ae3466953fa46db66ef1e0da.svg";
export { ForwardRef as ReactComponent };